/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_DescriptionInputs */

const en_reading_labels_description = /** @type {(inputs: Reading_Labels_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose which parts of this document are read aloud.`)
};

const es_reading_labels_description = /** @type {(inputs: Reading_Labels_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige qué partes de este documento se leen en voz alta.`)
};

/**
* | output |
* | --- |
* | "Choose which parts of this document are read aloud." |
*
* @param {Reading_Labels_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_description = /** @type {((inputs?: Reading_Labels_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_description(inputs)
	return en_reading_labels_description(inputs)
});